import { Divider, Stack } from '@mui/material';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import routes from 'constants/routes';
import ActivityContainer from 'components/Common/ActivityContainerTable';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, store } from 'redux/store';
import { dateFormat, formatAmount, getAccountActivityTrxDetail, getTodayFilter, timeFormat } from 'utils/helpers';
import { fetchAccountActivity } from 'redux/slices/dashboard/accountActivitySlice';

const SendMoneyContainer = () => {
    // const textInputPlaceholders = ['Total Sent', 'Total Transaction'];
    const navigate = useNavigate();
    const dispatch = useDispatch<typeof store.dispatch>();
    const tableState = useSelector((state: RootState) => state.app.table);
    const { pageNumber, ...rest } = tableState;
    const sendMoneyRecords = useSelector((state: RootState) => state.accountActivity?.sendMoneyRecords);
    const loading = useSelector((state: RootState) => state.accountActivity?.loading);
    const [filter, setFilter] = useState({ ...getTodayFilter(), ...rest });
    const columns = [
        { id: 'transactionDate', label: 'Date', render: ({ data }: any) => dateFormat(data?.transactionDateTime) },
        { id: 'transactionTime', label: 'Time', render: ({ data }: any) => timeFormat(data?.transactionDateTime, 'hh:mm A') },
        {
            id: 'event.username',
            label: 'From',
            render: ({ data }: any) => data?.filteredData?.fromUsername,
        },
        {
            id: 'companyName',
            label: 'To',
            render: ({ data }: any) => data?.filteredData?.toUsername,
        },
        {
            id: 'transactionType',
            label: 'Type',
            render: ({ data }: any) => data?.filteredData?.transactionType,
        },

        { id: 'amount', label: 'Total', render: ({ data }: any) => formatAmount(data?.amount, 'dollar', data?.type) },
    ];

    useEffect(() => {
        dispatch(fetchAccountActivity({ filter: { role: 'SENDER', ...filter }, type: 'sendMoney' }));
    }, [dispatch, filter]);

    const navigationHandler = (row: any) => {
        const filterTrxData = getAccountActivityTrxDetail(row);
        navigate(routes.transactions.transactionDetails.replace(':transactionId', row?.confirmationCode?.toString()), {
            state: { filterTrxData },
        });
    };

    return (
        <Stack width={'100%'} direction={{ xs: 'column', sm: 'row' }}>
            <Stack width={'100%'} sx={{ backgroundColor: 'white', p: 1, mx: 2 }}>
                <Divider />
                <ActivityContainer
                    totalSent={''}
                    totalTransactions={''}
                    // textInputPlaceholders={textInputPlaceholders}
                    navigationHandler={navigationHandler}
                    records={sendMoneyRecords}
                    columns={columns}
                    filter={filter}
                    loading={loading}
                    setFilter={setFilter}
                    serverSidePagination
                    defaultPagination={false}
                />
            </Stack>
        </Stack>
    );
};

export default SendMoneyContainer;
